/**
 * Serializa un esquema para incrustarlo como hijo de texto de un
 * <script type="application/ld+json"> dentro de <Helmet>.
 *
 * Dos motivos para pasar siempre por aquí en lugar de dangerouslySetInnerHTML:
 *
 *  1. react-helmet-async solo reconoce el contenido de un <script> cuando llega
 *     como hijo de texto: mapea `children` a la prop interna `innerHTML` y
 *     después descarta cualquier etiqueta que no tenga `src` ni `innerHTML`.
 *     Con dangerouslySetInnerHTML el script se cae entero y el JSON-LD nunca
 *     llega al HTML (ni en el dev server ni en el prerender).
 *  2. Helmet vuelca ese texto con innerHTML, así que un "</script>" dentro de
 *     cualquier cadena del esquema cerraría la etiqueta antes de tiempo.
 *     Escapamos "<" como \\u003c, que es JSON válido y los parsers de JSON-LD
 *     deshacen sin cambiar el contenido.
 */
export const toJsonLd = (schema) => JSON.stringify(schema).replace(/</g, '\\u003c');

export default toJsonLd;
